import React from 'react';

import { Box, Stack, Tooltip } from '@mui/material';

import { cellStyle, getTooltipTitle } from './helper';
import TableTooltip from './TableTooltip';
import { GridCellExpand } from '../../../RiverusUI/DataGrid/GridCellExpand';

const CustomGridTreeDataGroupingCell = (props: any) => {
  const { row, progress, isProcessing, notStarted, failed, colDef, minWidth } =
    props;

  const handleOpenContract = (contractData: any) => {
    window.open(
      '/document/documentlibrary/' + btoa(contractData?.id?.toString()),
      '_blank'
    );
  };

  return (
    <Tooltip
      title={getTooltipTitle({
        isProcessing,
        notStarted,
        failed,
        progress,
      })}
      arrow
    >
      <Stack
        sx={{ minHeight: '54px', minWidth: minWidth || '240px' }}
        height="-webkit-fill-available"
        justifyContent="center"
        flex={1}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
          sx={{
            ...cellStyle({ notStarted, isProcessing }),
          }}
        >
          <Box sx={{ maxWidth: '200px' }}>
            <GridCellExpand
              value={row?.title}
              width={colDef?.computedWidth}
              onClick={() => handleOpenContract(row)}
            />
          </Box>
          <TableTooltip contractData={row} />
        </Stack>
      </Stack>
    </Tooltip>
  );
};

export default CustomGridTreeDataGroupingCell;
